define.alias("shared/components/shared/social-set-icons", "media/components/shared/social-set-icons");